var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "18px",
    viewBox: "0 0 27 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9B310E12-E4CD-44EA-9108-9A85168FA780") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gydytoj\\u0173-s\\u0105ra\\u0161as",
    transform: "translate(-165.000000, -198.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.849591,198.849591 L190.788,205.788 L190.826087,205.788225 L190.826,205.826 L191.849591,206.849591 L190.826,207.872 L190.826087,208.050967 L190.648,208.05 L183.548772,215.150409 L181.948772,213.550409 L187.447,208.05 L165,208.050967 L165,205.788225 L187.467,205.788 L182.189427,200.509754 L183.849591,198.849591 Z",
    id: "back-copy",
    transform: "translate(178.500000, 207.000000) scale(-1, 1) translate(-178.500000, -207.000000) "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.16b86cf169a399b7652a7e6f1c698c2f.svg";
export { ForwardRef as ReactComponent };